module.exports = __webpack_public_path__ + "media/images/logo-13af583b48e54cf5c1f4c4920d0d86c9.svg";